var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordD7 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 27.99,
  d: "M113.29 116.4h371.92v371.92H113.29z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#faa725",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 10.35,
  d: "M179.24 392q14.52-1.54 18.93-5.22t4.4-18.63V250.06q0-14.52-4.27-18.67t-19.06-5.18v-4.93h71.56q36.17 0 61.19 11.93 45.11 21.39 45.11 76.48a90.44 90.44 0 01-8.1 37.73 77.44 77.44 0 01-24.44 30.2 82.34 82.34 0 01-21.56 11.8q-20.35 7.51-50 7.52h-73.76zm53.47-7q3.18 2.08 13.16 2.08 31.11 0 51.21-12.33 30.85-18.94 30.85-64.74 0-40.87-25.41-61.5-21.78-17.64-57.68-17.65c-6 0-10 .66-12.13 1.95s-3.17 4.15-3.17 8.56v135.08c0 4.32 1.06 7.18 3.17 8.55z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e92827",
  stroke: "#e92827",
  strokeMiterlimit: 10,
  strokeWidth: 5.2,
  d: "M421.8 192.42v2.15l-28.27 87.35H385l26.33-79.66h-28.4q-6.32 0-9.08 2.08t-7 8.73l-2.27-1q4.23-10.42 5.24-12.86t2.64-6.75z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 113.29,
  cy: 488.32,
  r: 63.19,
  fill: "#fff",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  transform: "rotate(-89.27 113.267 488.304)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#faa725",
  stroke: "#faa725",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M98.08 467.62a91.57 91.57 0 0113.39-1.12c9-.07 15.5 2 19.79 5.92s6.93 9.57 7 17.46-2.38 14.49-6.92 19-12 7.12-21.53 7.2a102.27 102.27 0 01-11.44-.48zm6.53 43.09a40.34 40.34 0 006.39.29c13.46-.12 20.73-7.71 20.66-20.88 0-11.51-6.54-18.77-19.86-18.66a36.44 36.44 0 00-7.38.71z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M174.93 109.83a61.64 61.64 0 11-61.64-61.64 61.64 61.64 0 0161.64 61.64z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#64c083",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M85.24 89.27h26.27v5.29h-20v16.21H110V116H91.53v22.08h-6.29z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#64c083",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  d: "M121.37 121.27l1.88-14.18h-5.94v-4.28h6.59l1.38-10.49h-6.23v-4.27h6.88l1.88-13.83H132l-1.8 13.83h7.53l1.88-13.83h4.27l-1.81 13.83H148v4.27h-6.59l-1.3 10.49h6.22v4.28h-6.88l-1.88 14.18h-4.34l1.88-14.18h-7.53l-1.88 14.18zm14.4-18.46l1.38-10.49h-7.53l-1.38 10.49z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M544.23 113.27a61.64 61.64 0 11-61.64-61.63 61.64 61.64 0 0161.64 61.63z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8f6daf",
  stroke: "#8f6daf",
  strokeMiterlimit: 10,
  strokeWidth: 4.88,
  d: "M475.76 122.48l-5.07 15.34h-6.52L480.75 89h7.6L505 137.82h-6.73l-5.21-15.34zm16-4.93l-4.77-14c-1.09-3.18-1.81-6.08-2.54-8.9h-.14c-.73 2.89-1.52 5.86-2.46 8.83l-4.78 14.11z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e92827",
  strokeMiterlimit: 10,
  strokeWidth: 22.91,
  d: "M549.9 483.32c0 34.37-28.5 62.24-63.65 62.24s-63.66-27.87-63.66-62.24 28.5-62.24 63.66-62.24 63.65 27.86 63.65 62.24z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#e92827",
  stroke: "#e92827",
  strokeMiterlimit: 10,
  strokeWidth: 8.18,
  d: "M500.35 505.54c-2.34 1.15-7 2.3-13.05 2.3-13.93 0-24.42-8.61-24.42-24.45 0-15.13 10.49-25.39 25.81-25.39 6.16 0 10.05 1.29 11.74 2.16l-1.54 5.09a23.66 23.66 0 00-10-2c-11.58 0-19.28 7.24-19.28 19.93 0 11.83 7 19.43 19 19.43a26.15 26.15 0 0010.41-2z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordD7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-d7.85b67e42995fbef0b9ae34bb9da45006.svg";